<script setup lang="ts">
definePageMeta({
  layout: false,
  auth: false,
})

// Its URL in Czech, German and Polish (constants/localizedRoutes.ts).
false && /*#__PURE__*/ defineI18nRoute({ paths: { cs: '/statistiky-zivotopisu', de: '/lebenslauf-statistiken', pl: '/statystyki-cv' } })
</script>

<template>
  <MarketingFeaturePage seo-key="cvAnalytics" path="/cv-analytics">
      <LazyHomepageAnalyticsSection />
      <LazyMarketingLinkTrackingShowcase alt />
  </MarketingFeaturePage>
</template>
